import {
    getCookie
} from '../global/_cookies';

var miniCartCookie = getCookie('301_CVMINICART');
export const lazyLoadMyDillardsBar = () => {
    if (!$('#myDillardsDropDown').is(":visible") && $('#myDillardsRightFrame').attr('src') == '' || miniCartCookie != getCookie('301_CVMINICART')) {
        miniCartCookie = getCookie('301_CVMINICART');
        $('#myDillardsRightFrame').attr('src', $('#myDillardsRightFrame').data('src'));
    }
};
